export const views = {
  projectOverview: 'projectOverview',
  approvals: 'approvals',
  expenses: 'expenses',
  projects: 'projects',
  invoiceManagement: 'invoiceManagement',
  wip: 'wip',
  wipAi: 'wipAi',
}
